import React from 'react'

function AdditionalInfoOnCaseDetails({caseDetails}) {
  return (
    <>
      {caseDetails?.additionalNotes && 
        <div className='flex w-full'>
            <div className='shadow-xl border w-full p-4  mt-10'>
            <div className='flex w-full flex-col'>
                <div className='w-max text-sky-600 w-full'>Extra information on the issue : </div>
        
                <div className='flex mt-4 items-baseline'>
                  <div className='mr-1'>{caseDetails?.additionalNotes}</div>
                </div>
            </div>
            </div>
         </div>
      }
    </>
  )
}

export default AdditionalInfoOnCaseDetails